<template>
  <div class="main-layout">
    <div class="layout-content">
      <slot></slot>
      <SiteFooter/>
    </div>
  </div>

  <PopupViewer/>
</template>

<script setup lang="ts">
import PopupViewer from './PopupViewer.vue';
import SiteFooter from './SiteFooter.vue';
import { onBeforeMount } from 'vue';
import { useLocalFonts } from '../../composables/useLocalFonts';

let { updateFont } = useLocalFonts();

onBeforeMount(() => {
  updateFont();
});
</script>

<style scoped>
.main-layout {
  min-height: 100vh;
  background: #000000;
  color: #ffffff;
  display: flex;
  justify-content: center;
}

.layout-content {
  width: var(--content-max-width);
  max-width: 100%;
  margin: 0 auto;
  min-height: 100%;
}

@media (max-width: 800px) {
  .main-layout {
    padding: 0px;
  }
}

@media (max-width: 576px) {
  .main-layout {
    padding: 0px;
  }
}
</style>
